import React from "react";
import { Link } from "react-router-dom";
import CredibilityBar from "@/components/CredibilityBar";
import { AX_HOME as HOME } from "@/constants/testIds";

// Deterministic UTC-day rotation. The same dossier is featured for everyone
// worldwide on any given calendar day (UTC). Sorted alphabetically by slug so
// the rotation order is stable regardless of insertion order in the DB.
export const pickFeatured = (theories, now = new Date()) => {
  if (!theories || theories.length === 0) return null;
  const sorted = [...theories].sort((a, b) => a.slug.localeCompare(b.slug));
  const utcStart = Date.UTC(now.getUTCFullYear(), 0, 0);
  const utcDayMs = 24 * 60 * 60 * 1000;
  const dayOfYear = Math.floor(
    (Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()) -
      utcStart) /
      utcDayMs
  );
  const idx = ((dayOfYear - 1) % sorted.length + sorted.length) % sorted.length;
  return sorted[idx];
};

const FeaturedDossier = ({ theories }) => {
  const featured = pickFeatured(theories);
  if (!featured) return null;

  const dateStr = new Date().toLocaleDateString(undefined, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const cred =
    featured.community_credibility != null
      ? featured.community_credibility
      : featured.base_credibility;

  return (
    <div data-testid={HOME.featured} className="featured-card fade-in">
      <div className="featured-header">
        <span className="featured-stamp">
          {"┌─[ TODAY'S DECLASSIFIED FILE ]"}
          <span className="cursor" />
        </span>
        <span
          data-testid={HOME.featuredDate}
          className="featured-date"
          title="The featured dossier rotates daily — same one worldwide."
        >
          {dateStr.toUpperCase()}
        </span>
      </div>

      <Link
        to={`/theories/${featured.slug}`}
        data-testid={HOME.featuredLink}
        className="featured-body"
      >
        <div className="kbd-label">// rotating · daily</div>
        <h2 className="featured-title glow">
          {featured.title}
        </h2>
        <div style={{ marginTop: "0.8rem", maxWidth: 640 }}>
          <CredibilityBar
            score={cred}
            label={
              featured.community_credibility != null ? "COMMUNITY" : "BASELINE"
            }
          />
        </div>
        <div className="featured-cta">
          <span className="cta-arrow">{"→"}</span> OPEN DOSSIER
        </div>
      </Link>
    </div>
  );
};

export default FeaturedDossier;
